<template>
  <div>
      <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12 pt-0>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <!-- <th class="text-left text-uppercase">Seller Code</th> -->
                <th class="text-left text-uppercase">Name</th>
                <th class="text-left text-uppercase">Email</th>
                <th class="text-left text-uppercase">Phone</th>
                <th class="text-left text-uppercase">Created Date</th>
                <th class="text-left text-uppercase">Status</th>
                <th class="text-left text-uppercase">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, i) in customerData"
                :key="i"
              
                style="cursor: pointer; height: 90px"
                @click="$router.push('/CustomerInfo?customer=' + item._id)"
              >
                <!-- <td>{{ item.usercode }}</td> -->

                <td>
                  <span v-if="item.customerid">
                    {{ item.customerid.firstName }}
                    {{ item.customerid.lastName }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="item.customerid">
                    {{ item.customerid.email }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="item.phone"> {{ item.phone }}</span>
                  <span v-else>-</span>
                </td>
                <td>{{ item.create_date.slice(0, 10) }}</td>

                <td>{{ item.status }}</td>
                  <td style="width: 5%">
                  <v-btn
                    color="red"
                    small
                    outlined
                    @click.stop="(deleteData = item), (deleteDialog = true)"
                  >
                    Delete
                  </v-btn>
                </td>
                <!-- <td>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm3 lg12 align-self-center text-left>
                      <v-btn
                        plain
                        text
                        :to="'/CustomerInfo?customer=' + item._id"
                      >
                        <v-icon color="green">mdi-eye</v-icon>
                      </v-btn>
                    </v-flex>
               
                  </v-layout>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <!-- <v-dialog persistent v-model="editDialog" max-width="70%">
      <v-card>
        <v-card-title style="font-family:poppinssemibold;font-size:16px"
          >Request</v-card-title
        >
        <v-layout wrap>
          <v-flex xs12 align-self-center px-6>
            <v-layout wrap pt-2>
              <v-flex xs12 sm6 text-left>
                <span>Seller Code</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.usercode}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.sellerProfileId">
              <v-flex xs12 sm6 text-left>
                <span>Seller Name</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.sellerProfileId.name}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.email">
              <v-flex xs12 sm6 text-left>
                <span>Email</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.email}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.phone">
              <v-flex xs12 sm6 text-left>
                <span>Phone</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.phone}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="getData(), (updateDialog = false)"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="updateStatus(dialogId, dialogStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
     <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title
          >Are you sure you want to remove this customer</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["customerData", "pages", "filter"],
  // props: ["fromDate","toDate","programme"],
  data() {
    return {
      currentPage: 1,
      // pages: 0,
      // customerData: [],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      deleteDialog: false,
      msg: null,
      deleteData:{}
    };
  },
  // watch: {
  //   currentPage() {
  //     this.winStepper();
  //   },
  // },

  watch: {
    fromDate() {
      // this.getData()
    },
    toDate() {
      // this.getData()
    },
    programme() {
      // this.getData()
    },
    currentPage() {
      // this.getData();
      this.winStepper();
    },
  },
  beforeMount() {
    // this.getData()
    this.winStepper();
  },
  methods: {
    winStepper() {
      // console.log("step", this.currentPage);
      // alert("my call win comp")
      this.$emit("stepper", {
        // getData: true,
        currentPage: this.currentPage,
        pages: this.pages,
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          role: "Customer",
          status: this.filter,
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.customers = response.data.data;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
       deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/delete/",
        data: {
          id: this.deleteData._id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });  
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
  },
};
</script>